/* ashed.in on Shopify — cart, quantity, share, nav.
   The cart itself is Shopify's: /cart/add.js and /cart/change.js. Tier pricing
   is an automatic discount on the store, so nothing here computes a price. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------- phone menu ----------
     Ported from the old shop.js: the burger opens a full sheet. Toggling a
     class alone does nothing — no rule in style.css answers to it. */
  (function buildMenu() {
    const burgers = $$('.nav-burger');
    if (!burgers.length) return;
    const sheet = document.createElement('div');
    sheet.className = 'menu-sheet';
    sheet.hidden = true;
    sheet.innerHTML = `
      <button class="menu-close" type="button" aria-label="Close menu">×</button>
      <nav class="menu-links">
        <a href="/">Home</a>
        <a href="/collections/site">Products</a>
        <a href="/collections">Collections</a>
        <a href="/pages/b2b">B2B &amp; bulk</a>
        <a href="/blogs/journal">Blog</a>
        <a href="/pages/contact">Contact</a>
        <a href="/pages/affiliate">Affiliates</a>
        <a href="/cart">Cart<span class="cart-n" data-cart-count></span></a>
      </nav>`;
    document.body.appendChild(sheet);
    const open = o => {
      sheet.hidden = !o;
      document.documentElement.style.overflow = o ? 'hidden' : '';
      burgers.forEach(b => b.setAttribute('aria-expanded', String(o)));
      if (o) $('.menu-close', sheet).focus();
    };
    burgers.forEach(b => b.addEventListener('click', () => open(sheet.hidden)));
    sheet.addEventListener('click', e => {
      if (e.target === sheet || e.target.closest('.menu-close')) open(false);
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !sheet.hidden) open(false); });
  })();

  /* ---------- the reel ----------
     Its drifting track defeats native lazy-loading, because positions are
     judged before the transform, so the band loads its own images. Ported
     from the inline script at the bottom of the old index.html. */
  (function reel() {
    const track = $('[data-reel]');
    if (!track) return;
    const loadAll = () => $$('img[data-src]', track).forEach(im => { im.src = im.dataset.src; im.removeAttribute('data-src'); });
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(entries => {
        if (entries.some(e => e.isIntersecting)) { loadAll(); io.disconnect(); }
      }, { rootMargin: '1200px 0px' });
      io.observe(track.parentElement);
      setTimeout(() => { loadAll(); io.disconnect(); }, 8000);   // belt and braces
    } else loadAll();
    const art = card => { const a = $('[data-art]', card); if (a && !a.src) a.src = a.dataset.art; };
    track.addEventListener('pointerover', e => { const c = e.target.closest('.reel-card'); if (c) art(c); });
    track.addEventListener('touchstart', e => { const c = e.target.closest('.reel-card'); if (c) art(c); }, { passive: true });
  })();

  /* ---------- affiliate signup ----------
     Shows the visitor their code the moment they register; the enquiry itself
     goes to Shopify through the form. */
  (function affiliate() {
    const form = document.getElementById('affForm') || $('form[action*="/contact"] [name="contact[Affiliate ID — short, you\'ll share it]"]')?.closest('form');
    const out = document.getElementById('affResult');
    if (!form || !out) return;
    const clean = v => String(v || '').toUpperCase().replace(/[^A-Z0-9-]/g, '').slice(0, 24);
    form.addEventListener('submit', e => {
      const idField = [...form.querySelectorAll('input')].find(i => /Affiliate ID/i.test(i.name));
      const nameField = form.querySelector('[name="contact[name]"]');
      const id = idField ? idField.value.trim() : '';
      const code = clean('ASHED-' + id);
      if (!nameField?.value.trim() || code.length < 8) {
        e.preventDefault();
        e.stopImmediatePropagation();
        toast('Enter a name and an ID of at least 2 characters');
        return;
      }
      const link = `${location.origin}/?ref=${code}`;
      out.hidden = false;
      const codeEl = $('[data-aff-code]', out), linkEl = $('[data-aff-link]', out);
      if (codeEl) codeEl.textContent = code;
      if (linkEl) linkEl.textContent = link;
      $$('[data-copy]', out).forEach(btn => {
        btn.onclick = async () => {
          const text = btn.dataset.copy === 'code' ? code : link;
          try { await navigator.clipboard.writeText(text); toast('Copied'); }
          catch { toast(text); }
        };
      });
      setTimeout(() => { const sent = $('[data-aff-sent]', out); if (sent) sent.hidden = false; }, 950);
      out.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  })();

  /* ---------- affiliate referral ----------
     ?ref=CODE lands from a partner's link; remember it and put it in the cart's
     discount box, so the code the visitor was promised is the one applied. */
  (function referral() {
    const KEY = 'ashed-ref';
    try {
      const fromUrl = new URLSearchParams(location.search).get('ref');
      if (fromUrl) localStorage.setItem(KEY, String(fromUrl).toUpperCase().replace(/[^A-Z0-9-]/g, '').slice(0, 24));
      const ref = localStorage.getItem(KEY);
      const input = document.getElementById('refInput');
      if (ref && input && !input.value) input.value = ref;
    } catch { /* private browsing */ }
  })();

  /* ---------- toast ---------- */
  let toastTimer = null;
  function toast(msg) {
    let el = $('.toast');
    if (!el) { el = document.createElement('div'); el.className = 'toast'; document.body.appendChild(el); }
    el.textContent = msg;
    el.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-on'), 2400);
  }

  /* ---------- quantity stepper ---------- */
  document.addEventListener('click', e => {
    const box = e.target.closest('[data-qty]');
    if (!box) return;
    const input = $('input', box);
    if (!input) return;
    const n = Math.max(1, parseInt(input.value, 10) || 1);
    if (e.target.closest('[data-plus]')) input.value = n + 1;
    if (e.target.closest('[data-minus]')) input.value = Math.max(1, n - 1);
  });

  /* ---------- cart count ---------- */
  const paintCount = n => $$('[data-cart-count]').forEach(el => { el.textContent = n > 0 ? ` · ${n}` : ''; });

  /* ---------- add to cart ----------
     The form posts natively without JS; this upgrades it to stay on the page. */
  $$('form[data-buy]').forEach(form => form.addEventListener('submit', async e => {
    e.preventDefault();
    const btn = $('button[type="submit"]', form);
    if (btn) btn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: Number(form.querySelector('[name="id"]').value),
          quantity: Math.max(1, parseInt(form.querySelector('[name="quantity"]').value, 10) || 1),
        }),
      });
      if (!res.ok) throw new Error((await res.json()).description || 'Could not add to cart');
      const cart = await (await fetch('/cart.js')).json();
      paintCount(cart.item_count);
      toast('Added to cart');
    } catch (err) {
      toast(String(err.message || err));
    } finally {
      if (btn) btn.disabled = false;
    }
  }));

  /* ---------- cart page rows ---------- */
  $$('[data-line]').forEach(row => row.addEventListener('click', async e => {
    const delta = e.target.closest('[data-plus]') ? 1 : e.target.closest('[data-minus]') ? -1 : e.target.closest('[data-remove]') ? 'x' : null;
    if (delta === null) return;
    e.preventDefault();
    const line = Number(row.dataset.line);
    const now = Number(row.dataset.qty);
    const quantity = delta === 'x' ? 0 : Math.max(0, now + delta);
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity }),
    });
    if (res.ok) location.reload();
  }));

  /* ---------- product gallery ----------
     Ported from the old site's catalog.js, which the theme drops. The big
     image carries a srcset, and srcset OVERRIDES src — swapping one without
     the other leaves the browser showing the old candidate. */
  const product = $('[data-product]');
  if (product) {
    const showAngle = thumb => {
      const main = $('.pp-main', product);
      if (main) {
        const u = thumb.dataset.full;                    // …width=1600
        main.srcset = [800, 1200, 1600].map(w => `${u.replace(/width=1600/, 'width=' + w)} ${w}w`).join(', ');
        main.src = u;
      }
      $$('.pp-thumb', product).forEach(x => x.classList.toggle('is-on', x === thumb));
    };
    /* delegated, so it survives anything that replaces the nodes */
    product.addEventListener('click', e => {
      const thumb = e.target.closest('.pp-thumb');
      if (thumb) showAngle(thumb);
    });
    $$('.pp-thumb', product).forEach(t => { t.onclick = () => showAngle(t); });
    product.addEventListener('keydown', e => {
      const thumb = e.target.closest('.pp-thumb');
      if (!thumb || (e.key !== 'Enter' && e.key !== ' ')) return;
      e.preventDefault();
      showAngle(thumb);
    });
  }

  /* ---------- share ---------- */
  const share = $('[data-share]');
  if (share) {
    const url = share.dataset.url, title = share.dataset.title;
    const native = $('[data-native]', share);
    if (native && navigator.share) {
      native.hidden = false;
      native.addEventListener('click', () => navigator.share({ title, url }).catch(() => {}));
    }
    const copy = $('[data-copy]', share);
    if (copy) copy.addEventListener('click', async () => {
      try { await navigator.clipboard.writeText(url); toast('Link copied'); }
      catch { toast('Copy failed'); }
    });
  }
})();
